import { requestApi } from './Api';

export const getTerminals = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/terminal/list',
    onError: () => {},
    params
  });
};

export const getOneTerminal = async (navigate, params, { onError }) => {
  return requestApi({
    navigate,
    url: '/api/transactions/terminal/get',
    onError: onError ? onError : () => {},
    params
  });
};

export const addTerminal = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/terminal/add',
    onError: () => {},
    params
  });
};

export const updateTerminal = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/terminal/update',
    onError: () => {},
    params
  });
};

export const addTerminalGroup = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/group/add',
    params
  });
};

export const getTerminal = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/terminal/get_one',
    params
  });
};

export const selectVirtualTerminal = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/transactions/online/select',
    params
  });
};
